import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { GeneralDiscountForm } from "./components/generalDiscountForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const AddGeneralDiscount = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const handleAddDiscount = async (discountData) => {
    setCircleLoading(true);
    const payload = {
        name: discountData?.name,
        description: discountData?.description,
        maxLimit: discountData?.maxLimit,
        autoApply: discountData?.autoApply,
        mandatory: discountData?.mandatory,
        isActive: discountData?.active,
        productId: discountData?.productId?.value,
        policyTypeId: discountData?.policyTypeId || []   
    };
    try{
      const response = await postData("/reference/general/discount", payload);
      if(response?.success){
        navigate("/general-master/general-discount");
        showSnackbar(response?.message,"success");
      }
      else{
        showSnackbar("Error Adding","error");
      }
    }catch (error) {
      console.error("Eror Adding",error);
      showSnackbar(error?.response?.data?.message, "error");
    }finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-discount")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Discount details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add New Discount details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralDiscountForm onsubmit={handleAddDiscount} />
        </Box>
      </Card>      
    </DashboardLayout>
  );
};

export default AddGeneralDiscount;
